import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ManagerType } from '../../../types/Manager';

const initialState:ManagerType = {
  idUser: '',
  isManager: false
}
const managersSlice = createSlice({
  name: "managerForm",
  initialState,
  reducers: {
    setManagerData:(state, action:PayloadAction<ManagerType>)=>({...state, ...action.payload}), 
    resetManagerData :()=>({...initialState}),
    setManagerScope: (state, action: PayloadAction<{ faculties: string[]; departments: string[]; courses: string[] }>) => {
      state.faculties = action.payload.faculties;
      state.departments = action.payload.departments;
      state.courses = action.payload.courses;
    },
  }
});

export const {setManagerData,resetManagerData,setManagerScope } = managersSlice.actions

export default managersSlice.reducer